module.exports = __webpack_public_path__ + "img/sessionAssignment.69c038a2.png";